import apiClient from "../client";

// POST /api/ubl-pool/ceiling
// Body: { quarter, ceiling }
export const setUblCeiling = async (body) => {
  const response = await apiClient.post("/ubl-pool/ceiling", body);
  return response.data;
};

// GET /api/ubl-pool/status
export const getUblPoolStatus = async () => {
  const response = await apiClient.get("/ubl-pool/status");
  return response.data;
};

// GET /api/ubl-pool/settings — full audit history
export const getUblPoolSettings = async () => {
  const response = await apiClient.get("/ubl-pool/settings");
  return response.data;
};